import { entityRegistry } from '@rammetec/data-access';
import { vhAgentsDescriptor } from './vhAgents.descriptor.js';
import { moduleConfigDescriptor } from './moduleConfig.descriptor.js';
import { vhResourcesDescriptor } from './vhResources.descriptor.js';
import { vhTemplateSchemasDescriptor } from './vhTemplateSchemas.descriptor.js';
import { vhTokensDescriptor } from './vhTokens.descriptor.js';
import { vhUserAccessDescriptor } from './vhUserAccess.descriptor.js';
import { organizationReadDescriptor } from './organization.descriptor.js';
import { userOrgsDescriptor } from './userOrgs.descriptor.js';
import { PREFERENCE_ENTITY, preferenceDescriptors, } from './preferences.descriptor.js';
export { vhAgentsDescriptor, moduleConfigDescriptor, vhResourcesDescriptor, vhTemplateSchemasDescriptor, vhTokensDescriptor, vhUserAccessDescriptor, organizationReadDescriptor, userOrgsDescriptor, preferenceDescriptors, PREFERENCE_ENTITY, };
/** Register all VectorHub entity descriptors. Call once at console bootstrap (Phase 5). */
export function registerDescriptors() {
    entityRegistry.registerDescriptor(vhAgentsDescriptor);
    entityRegistry.registerDescriptor(moduleConfigDescriptor);
    entityRegistry.registerDescriptor(vhResourcesDescriptor);
    entityRegistry.registerDescriptor(vhTemplateSchemasDescriptor);
    entityRegistry.registerDescriptor(vhTokensDescriptor);
    entityRegistry.registerDescriptor(vhUserAccessDescriptor);
    entityRegistry.registerDescriptor(organizationReadDescriptor);
    entityRegistry.registerDescriptor(userOrgsDescriptor);
    entityRegistry.registerDescriptor(preferenceDescriptors.userPreference);
    entityRegistry.registerDescriptor(preferenceDescriptors.orgUserPreference);
    entityRegistry.registerDescriptor(preferenceDescriptors.orgPreferenceDefault);
}
//# sourceMappingURL=index.js.map